import { useEffect, useRef } from 'react';

/**
 * Invalidates in-flight migration upload polling when the wizard closes, leaves the migration-upload step,
 * or starts a new upload attempt. Pairs with per-attempt generation checks in the upload handler.
 */
export function useMigrationUploadPollSession(isOpen: boolean, currentStepId: string) {
  const generationRef = useRef(0);

  useEffect(() => {
    if (!isOpen || currentStepId !== 'migration-upload') {
      generationRef.current += 1;
    }
  }, [isOpen, currentStepId]);

  const beginNewUploadAttempt = () => {
    generationRef.current += 1;
    return generationRef.current;
  };

  const isAttemptCurrent = (generation: number) => () => generationRef.current === generation;

  return { beginNewUploadAttempt, isAttemptCurrent };
}
